import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const actualidad = {
	state: {
		noticias: '',
		noticiascategory: {
			'actualidad': [],
			'desarrollo-rural': [],
			'agricultura': [],
			'ganaderia': [],
		},
		categorias: {
			'actualidad': 'Actualidad',
			'desarrollo-rural': 'Desarrollo rural',
			'agricultura': 'Agricultura',
			'ganaderia': 'Ganadería',
		}
	},
	getters: {
		getCategorias: state => state.categorias,
		categoriaNoticias: (state) => {

			let noticias = state.noticias;

			if (!!noticias) {

				let categorias = new Array();

				noticias.forEach(noticia => {
					if (!categorias.some(c => c.slug == noticia.categoria.slug)) {
						categorias.push(noticia.categoria)
					}
				});

				return categorias;
			}
		},
		getNoticiasHome: state => {
			if (!!state.noticias) {
				return state.noticias.filter(n => {
					return (n.destacada == 1)
				})
			}
		},
		getNoticiasByCategory: state => {
			return (category) => {
				return state.noticiascategory[category];
			}
		},
		getNoticias:state => {
			return state.noticias;
		}
	},
	actions: {
		requestNoticias: ({ commit }, ) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/blogs`)
					.then(response => {
						commit('setNoticias', response.data.entries);
						resolve(true);
					})
					.catch(error => reject(error));

			});
		},
		requestByCategory: ({ commit }, cat) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/blogs/${cat}`)
					.then(response => {
						if (!!response.data.entries) {
							let data = {
								cat: cat,
								data: response.data.entries
							};
							commit('setNoticiasCat', data);
							resolve(true);
						}else{
							resolve(false);
						}
					})
					.catch(error => reject(error));

			});
		},
		requestNoticia: ({ commit }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/blog/${slug}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => reject(error));

			});
		},

	},
	mutations: {
		setNoticias: (state, noticias) => {
			state.noticias = noticias;
		},
		setNoticiasCat: (state, data) => {
			console.log(data);
			state.noticiascategory[data.cat] = data.data;
		}
	}
}

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/actualidad.js